import { queryOptions, keepPreviousData } from '@tanstack/react-query';
import { photoScanningApi } from './photo-scanning.api';
import type { ScanBatchListParams } from '../types';

export const photoScanningKeys = {
  all: ['photo-scanning'] as const,
  lists: () => [...photoScanningKeys.all, 'list'] as const,
  list: (filters: ScanBatchListParams) =>
    [...photoScanningKeys.lists(), filters] as const,
  details: () => [...photoScanningKeys.all, 'detail'] as const,
  detail: (id: number) => [...photoScanningKeys.details(), id] as const,
  metrics: () => [...photoScanningKeys.all, 'metrics'] as const
};

export const photoScanningQueries = {
  list: (filters: ScanBatchListParams = {}) =>
    queryOptions({
      queryKey: photoScanningKeys.list(filters),
      queryFn: () => photoScanningApi.getList(filters),
      placeholderData: keepPreviousData
    }),

  detail: (id: number) =>
    queryOptions({
      queryKey: photoScanningKeys.detail(id),
      queryFn: () => photoScanningApi.getById(id)
    }),

  metrics: () =>
    queryOptions({
      queryKey: photoScanningKeys.metrics(),
      queryFn: () => photoScanningApi.getMetrics(),
      refetchInterval: 5_000
    })
};
